import React, { Fragment, useEffect, useState } from 'react';
import SEO from '../utils/SEO';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';

import { tools } from '../utils';

import PageNotFound from './notFound';
import {
  ArrowBtn,
  ConcertDetailedBanner,
  TextWithReadMore,
  UpcomingConcertCard,
  ClipboardBtn,
  DownloadButton
} from '../components';

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
} from 'react-share';

import './../assets/styles/pages/_concert-inner.scss';
import { startLoader } from '../components/common/Loader';

const ConcertInner = ({ match, getConcert, ...props }) => {
  const [concert, setConcert] = useState(null);
  const [upcoming, setUpcoming] = useState(null);
  const [concertProgram, setConcertProgram] = useState(null);
  const [pageUrl, setPageUrl] = useState('');
  const windowWidth = tools.canUseDOM ? window.innerWidth : 1024;
  const windowHeight = tools.canUseDOM ? window.innerHeight : 800;

  useEffect(() => {
    if (props.concert?.error) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      startLoader();
      setPageUrl(window.location.href);
      document.querySelector('body').style.overflow = 'auto';
    }
  }, [match.params.url, props.concert.error]);

  useEffect(() => {
    getConcert(match.params.url).then((response) => {
      try {
        const {
          data: concert,
          upcoming,
          document: concertProgram,
        } = response?.res;
        setConcert(concert);
        setUpcoming(upcoming);
        setConcertProgram(concertProgram);
      } catch (err) {
        console.error(err);
      }
    });
  }, [match.params.url, match, getConcert]);

  useEffect(() => {
    document.getElementById('menuLogo').classList.add('showMenuLogo', 'mobile-header-logo');
    document.getElementById('headLine').classList.add('headline');
    document.getElementsByClassName('menu__bar__live__icon')[0].classList.add('live-btn-color');
    return () => {
      document.getElementById('menuLogo').classList.remove('showMenuLogo', 'mobile-header-logo');
      document.getElementsByClassName('menu__bar__live__icon')[0].classList.remove('live-btn-color');
      document.getElementById('headLine').classList.remove('headline');
    };
  }, [])

  const {
    banner: innerPoster,
    about,
    program,
    artists,
    ticket_url: ticketUrl,
  } = concert !== null && concert !== undefined ? concert : '';

  const metaConcert = props.concert?.items?.data;

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}

      {props.concert?.error && <PageNotFound loader={false} />}
      <SEO
        title={
          (concert &&
            concert !== undefined &&
            concert !== null &&
            concert.title !== null &&
            concert.title.replace(/(<([^>]+)>)/gi, '')) ||
          (metaConcert &&
            metaConcert !== undefined &&
            metaConcert !== null &&
            metaConcert.title !== null &&
            metaConcert.title.replace(/(<([^>]+)>)/gi, ''))
        }
        description={
          (concert &&
            concert !== undefined &&
            concert !== null &&
            concert.about !== null &&
            concert.about.replace(/(<([^>]+)>)/gi, '')) ||
          (metaConcert &&
            metaConcert !== undefined &&
            metaConcert !== null &&
            metaConcert.about !== null &&
            metaConcert.about.replace(/(<([^>]+)>)/gi, ''))
        }
        img={
          (concert &&
            concert !== undefined &&
            concert !== null &&
            concert.poster !== null &&
            concert.poster) ||
          (metaConcert &&
            metaConcert !== undefined &&
            metaConcert !== null &&
            metaConcert.poster !== null &&
            metaConcert.poster)
        }
      />

      <Link to='/' className='banner-logo concert__inner__logo'>
        <img src='/media/images/InClassicaColorLogo.png' alt='logo' />
      </Link>
      <div className='concert'>
        <section className='concert__hero'>
          <div
            className='concert__banner__img'
            style={{
              backgroundImage: `url('${innerPoster && innerPoster}')`,
            }}
          />
          <div className='concert__head' id='concert__head'>
            <div className='concert__detailed__banner'>
              <ConcertDetailedBanner
                concertDetails={concert !== null && concert}
              />
              {ticketUrl && (
                <ArrowBtn
                  buttonColor='black'
                  url={ticketUrl}
                  title='BUY TICKET'
                />
              )}
            </div>
          </div>
        </section>

        <section className='concert__main'>
          <div className='concert__details'>
            {about ? (
              <div className='concert__section concert__about'>
                <h2>About</h2>

                <TextWithReadMore
                  shortText={about}
                  longText={about}
                  textClass='concert__about__text'
                  useLong
                />
              </div>
            ) : (
              ''
            )}

            {program && program.length ? (
              <div className='concert__section concert__programme'>
                <h2>Programme</h2>

                {program.map((prog, i) => (
                  <div key={i} className='prog'>
                    {prog.upcoming ? (
                      <h3 key={i}>Comming Soon...</h3>
                    ) : (
                      <>
                        <h5 className='prog__subtitle__part'>{prog.part}</h5>

                        {prog.data.map((p, i) => (
                          <Fragment key={i}>
                            <h3 className='prog__composer'>{p.author}</h3>
                            <h4 className='prog__music'>{p.performance}</h4>
                            {prog.music_parts && prog.music_parts.length ? (
                              <ul>
                                {prog.music_parts.map((part, j) => (
                                  <li key={j}>{part.name}</li>
                                ))}
                              </ul>
                            ) : (
                              ''
                            )}
                          </Fragment>
                        ))}
                      </>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}

            {artists &&
              artists.map(
                (conductor) =>
                  conductor.role === 'conductor' && (
                    <div
                      key={conductor.id}
                      className='concert__section concert__conductor'
                    >
                      <h3
                        dangerouslySetInnerHTML={{
                          __html: `${conductor.name} ${conductor.surname}`,
                        }}
                      />
                      <h4>CONDUCTOR</h4>

                      {conductor.bio !== '' && (
                        <TextWithReadMore
                          shortText={conductor.bio}
                          longText={conductor.bio}
                          textClass='concert__conductor__text'
                        />
                      )}
                    </div>
                  )
              )}
            <div className='concert__section concert__soloists'>
              {artists &&
                artists.map(
                  (sol, i) =>
                    sol.role === 'soloist' && (
                      <div key={i} className='concert__soloist'>
                        <h3
                          className='sol__name'
                          dangerouslySetInnerHTML={{
                            __html: `${sol.name} ${sol.surname}`,
                          }}
                        />
                        <TextWithReadMore
                          shortText={sol.bio}
                          longText={sol.bio}
                          textClass='concert__sol__text'
                        />
                      </div>
                    )
                )}
            </div>

            <div className='concert__section concert__orchestras'>
              {artists &&
                artists.map(
                  (orc, i) =>
                    orc.role === 'orchestra' && (
                      <div key={i} className='concert__orchestra'>
                        <h3 className='orc__name'>{orc.name}</h3>
                        <TextWithReadMore
                          shortText={orc.bio}
                          longText={orc.bio}
                          textClass='concert__orc__text'
                        />
                      </div>
                    )
                )}
            </div>

            <div className='concert__section concert__sharing'>
              <h3 className='sharing__title'>SHARE ON:</h3>

              <div className='sharingBtns'>
                <FacebookShareButton
                  windowWidth={windowWidth}
                  windowHeight={windowHeight}
                  url={pageUrl}
                >
                  <FacebookIcon />
                </FacebookShareButton>

                <TwitterShareButton
                  windowWidth={windowWidth}
                  windowHeight={windowHeight}
                  url={pageUrl}
                >
                  <TwitterIcon />
                </TwitterShareButton>

                <WhatsappShareButton
                  windowWidth={windowWidth}
                  windowHeight={windowHeight}
                  url={pageUrl}
                >
                  <WhatsappIcon />
                </WhatsappShareButton>

                <ClipboardBtn url={pageUrl} btnClass='clipboardBtn' />
              </div>
            </div>

            {concertProgram &&
              Object.keys(concertProgram).length &&
              concertProgram.url !== '' && (
                <div className='concert__section concert__download'>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: concertProgram && concertProgram?.label,
                    }}
                  />

                  <DownloadButton
                    downloadUrl={concertProgram && concertProgram?.url}
                    btnTitle='download'
                  />
                </div>
              )}
          </div>

          {upcoming && upcoming.length ? (
            <div className='concert__section concert__upcomings'>
              <div className='concerts__text'>
                <span>
                  <img
                    src='/media/icons/inclassica/calendar_inner.svg'
                    alt='calendar'
                  />
                </span>
                <h3>UPCOMING CONCERTS</h3>
              </div>
              <div className='concerts'>
                {upcoming.map((concert) => (
                  <UpcomingConcertCard data={concert} key={concert.id} />
                ))}
              </div>
            </div>
          ) : (
            ''
          )}
        </section>
      </div>

    </>
  );
};

function mapState (state) {
  return {
    concert: state.getConcert,
  };
}

ConcertInner.propTypes = {
  match: PropTypes.object,
  getConcert: PropTypes.func,
  concert: PropTypes.object,
};

const mapDispatchToProps = {
  getConcert: userActions.getConcert,
};

ConcertInner.serverFetch = (url) => mapDispatchToProps.getConcert(url);

export default connect(mapState, mapDispatchToProps)(ConcertInner);
